<template>
  <div
    :class="{
      empty: !comments.length,
    }"
  >
    <template v-if="comments.length">
      <comment
        v-for="comment in comments"
        :key="comment.id"
        :entity="entity"
        :entity-id="entityId"
        :comment="comment"
        :can-edit="canEdit"
        :active-form="activeForm"
        @formOpened="$emit('formOpened', $event)"
        @commentAdded="$emit('commentAdded', $event)"
        @commentUpdated="$emit('commentUpdated', $event)"
        @commentRemoved="$emit('commentRemoved', $event)"
        @commentRestored="$emit('commentRestored', $event)"
      />
    </template>

    <template v-else>
      <div class="not-found">Комментариев пока нет</div>
    </template>
  </div>
</template>

<script>
import Comment from "./Comment";

export default {
  components: { Comment },
  props: ["comments", "entity", "entityId", "canEdit", "activeForm"],
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";
.empty {
  display: flex;
  align-items: center;
  justify-content: center;
}
.not-found {
  color: $label;
  font-size: 13px;
}
</style>
